import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Seo from '../../../components/common/Seo'
import Sidebar from '../../../components/rsldashboard/common/Sidebar'
import Header from '../../../components/header/header-rslhome'
import WishlistTableNew from '../../../components/rsldashboard/bookinglist/components/Wishlist';
import SegmentTab from '../../../components/GuestBooking/SegmentTab'
import TypeTab from '../../../components/GuestBooking/TypeTab'
import CustomTab from '../../../components/GuestBooking/CustomTab'
import BookingDetailsPage from '../../../components/GuestBooking/BookingDetailsPage'
import { useDispatch, useSelector } from '../../../redux/store'
import {
  listBooking,
  bookingUpcomingList,
  bookingCabsList,
  bookingListView,
  cancelTrip,
  getRating
} from '../../../redux/slices/product'
import { getBookingOrEnquiry, getFutureBookingList } from '../../../redux/slices/common'
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  CircularProgress
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { fetchSeoByPage } from '../../../lib/seoHelper'

const tabItems = [
  { type: 0, name: 'Upcoming' },
  { type: 1, name: 'History' }
]

const tripTabFilters = [
  { type: 0, label: "All", visible: true },
  { type: 1, label: "Cab", visible: true },
  { type: 2, label: "Hourly", visible: true },
  { type: 3, label: "Subscription", visible: true },
  { type: 4, label: "Personal Chauffeur", visible: true }
];

const getTabs = (showPersonalChauffeur) => {
  if (showPersonalChauffeur) return tripTabFilters;
  return tripTabFilters.filter(tab => tab.type !== 4); // or tab.label !== "Personal Chauffeur"
};

const Index = ({ meta }) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const {
    cancelTripRes,
    bookingList,
    tripList,
    cancelList,
    bookingListRec,
    bookingListRecUpcome,
    listBookingSuccessRes,
    bookingListRecCab,
    bookingListViewRes,
    taxilistRes,
    ratingRes
  } = useSelector(state => state.product)
  const { bookingOrEnquiryRes, futureBookingList } = useSelector(state => state.common)
  const { id, type } = router.query

  const [bookingDetails, setBookingDetails] = useState(false)
  const [bookingData, setBookingData] = useState([])
  const [activeTab, setActiveTab] = useState(1)
  const [mainActiveTab, setMainActiveTab] = useState(0)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [rationPopup, setRatingPopup] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loader, setLoader] = useState(false)
  const [loaderWishlist, setLoaderWishList] = useState(false)
  const [cancelStatus, setCancelStatus] = useState('')
  const [cabs, setCabs] = useState(null)
  const [value, setValue] = useState(0)
  const [segmentActiveTab, setSegmentActiveTab] = useState(0);
  const [typeActiveTab, setTypeActiveTab] = useState(0);
  const [dataFilter, setDataFilter] = useState({
    bookingId: '',
    type: null,
    rating: 0,
    comments: '',
    isBookingFlow: 1
  })
  const [rating, setRating] = useState(0)
  const [message, setMessage] = useState('')
  const rslKey = JSON.parse(sessionStorage.getItem('rslkey'))
  const [dataOne, setDataOne] = useState({
    userId: rslKey,
    email: '',
    loginType: 1,
    type: 6,
    isBookingFlow: 1
  })
  const [additionalData, setAdditionalData] = useState({
    userId: rslKey,
    email: '',
    loginType: 1,
    type: 6,
    isBookingFlow: 1
  })
  const [subActiveTab, setSubActiveTab] = useState(0)
  const [additionalDataForCabs, setAdditionalDataForCabs] = useState({
    start: 1,
    limit: 1000,
    userId: rslKey,
    isBookingFlow: 1
  })
  const [open, setOpen] = useState(false)
  const [cancelData, setCancelData] = useState(undefined)
  const [datas, setDatas] = useState([])
  const [directList, setDirectList] = useState(false)
  const [listData, setListData] = useState(null)
  const [isBookingFlow, setIsBookingFlow] = useState(1)
  const [bookingFlow, setBookingFlow] = useState(null)
  const [isApiCall, setIsApiCall] = useState(false)
  const [isBookEnq, setIsBookEnq] = useState(false)
  const [enquiryTab, setEnquiryTab] = useState([])
  const [mainTab, setMainTab] = useState([])
  const [currentTab, setCurrentTab] = useState('Activity')
  const [typeVal, setTypeVal] = useState(null);
  const [hasFutureBooking, setHasFutureBooking] = useState(false);
  const [showCard, setShowCard] = useState(false);

  const [tripId, setTripId] = useState(null);

  useEffect(() => {
    dispatch(getBookingOrEnquiry())

    const passengerId = JSON.parse(sessionStorage.getItem("rslkeyId"));

    {passengerId && dispatch(getFutureBookingList({ passengerId }))}
    // const obj = {
    //   "passenger_id": passengerId
    // }
    // dispatch(getFutureBookingList(obj));

  }, [dispatch])

  useEffect(() => {
    if (bookingOrEnquiryRes) setBookingFlow(bookingOrEnquiryRes)
  }, [bookingOrEnquiryRes])

  useEffect(() => {
    if (futureBookingList && futureBookingList?.details?.trip_id) {
      setHasFutureBooking(true);
      setShowCard(true);
      setTripId(futureBookingList?.details?.trip_id);
    }

  }, [futureBookingList])

  useEffect(() => {
    const dynamicMainTab = []
    const dynamicEnquiryTab = []

    dynamicMainTab.push(
      { type: 6, name: 'Activity' },
      { type: 1, name: 'Hotel' },
      { type: 2, name: 'Flight' },
      { type: 11, name: 'Cabs' }
    )

    if (bookingFlow !== null) {
      if (bookingFlow.holidayBookingFlow === 1) {
        dynamicMainTab.push({ type: 8, name: 'Holiday' })
      } else if (bookingFlow.holidayBookingFlow === 2) {
        dynamicEnquiryTab.push({ type: 8, name: 'Holiday' })
      }

      if (bookingFlow.staycationBookingFlow === 1) {
        dynamicMainTab.push({ type: 4, name: 'Staycation' })
      } else if (bookingFlow.staycationBookingFlow === 2) {
        dynamicEnquiryTab.push({ type: 4, name: 'Staycation' })
      }

      if (bookingFlow.busRentalBookingFlow === 1) {
        dynamicMainTab.push({ type: 7, name: 'Bus Rental' })
      } else if (bookingFlow.busRentalBookingFlow === 2) {
        dynamicEnquiryTab.push({ type: 7, name: 'Bus Rental' })
      }
    }

    if (bookingFlow?.visaBookingFlow === 1) {
      dynamicMainTab.push({ type: 10, name: 'Visa' })
    } else if (bookingFlow?.visaBookingFlow === 2) {
      dynamicEnquiryTab.push({ type: 10, name: 'Visa' })
    }

    setMainTab(dynamicMainTab)
    setCurrentTab(dynamicMainTab[0]?.name)
    setEnquiryTab(dynamicEnquiryTab)
  }, [bookingFlow])

  useEffect(() => {
    if (type !== null && type !== undefined) {
      const typeNumber = Number(type)
      const tabIndex = mainTab.findIndex(item => item.type === typeNumber)
      setMainActiveTab(tabIndex !== -1 ? tabIndex : 0)
    }
  }, [type, mainTab])

  useEffect(() => {
    if (id) {
      const obj = { bookingId: id, bookingType: parseInt(type) }
      dispatch(bookingListView(obj))
    } else {
      setListData(null)
      setActiveTab(
        sessionStorage.getItem('active-tab')
          ? parseInt(sessionStorage.getItem('active-tab'))
          : 1
      )
    }
  }, [id, type])

  useEffect(() => {
    if (bookingListViewRes) {
      setLoading(false)
      setListData(bookingListViewRes)
      setBookingData([bookingListViewRes])
    } else {
      setListData(null)
    }
  }, [bookingListViewRes])

  const handleBookingCancel = () => {
    setLoading(true)
    dispatch(
      cancelTrip({
        bookingId: cancelData?.bookingId,
        type: cancelData?.type
      })
    ).then(() => setLoading(false))
  }

  useEffect(() => {
    if (cancelTripRes !== undefined) {
      if (cancelTripRes?.status !== -1) {
        setCancelStatus(cancelTripRes)
        setOpen(false)
        setCancelData(undefined)
      }
    } else {
      setCancelStatus(undefined)
      setOpen(false)
      setCancelData(undefined)
    }
  }, [cancelTripRes])

  const handleOpen = (bookingId, type) => {
    setOpen(true)
    setCancelData({ bookingId, type })
  }
  const handleClose = () => {
    setOpen(false)
    setCancelData(undefined)
  }

  useEffect(() => {
    if (
      id &&
      type &&
      !directList
    ) {
      setBookingData([])
      setDatas([])

      const temp = JSON.parse(sessionStorage.getItem('rslkey'))
      dispatch(
        bookingUpcomingList({
          userId: temp,
          email: '',
          loginType: 1,
          isBookingFlow: 1
        })
      )

      setBookingDetails(true)
      setDataOne(prev => ({ ...prev, type: 0 }))
    }
  }, [type, id])

  useEffect(() => {
    if (id && type && !directList) {
      setDirectList(false)
      const findIndex = tabItems.findIndex(t => t.type === Number(type))

      if (listBookingSuccessRes) {
        if (Array.isArray(listBookingSuccessRes)) {
          const checkId = listBookingSuccessRes.filter(d => d._id == id)
          setDatas(listBookingSuccessRes)
          setBookingData(checkId)
          setLoading(false)
          sessionStorage.setItem('active-tab', findIndex)
          setIsApiCall(false)
        } else {
          console.error('listBookingSuccessRes is not an array')
        }
      }
    }
  }, [listBookingSuccessRes])

  const handleOpenRating = () => setRatingPopup(true)
  const handleRatingClose = () => {
    setDataFilter({ bookingId: '', type: null, rating: 0, comments: '', isBookingFlow: 1 })
    setRatingPopup(false)
    setRating(0)
  }
  const handleSubmit = () => {
    setLoaderWishList(true)
    dispatch(getRating(dataFilter))
  }

  useEffect(() => {
    if (ratingRes) {
      setLoaderWishList(false)
      if (ratingRes?.status === 1) {
        setMessage('')
        setRatingPopup(false)
        window.open(`/rsldashboard/bookinglist`, '_self')
      } else {
        setMessage(ratingRes?.message)
      }
    }
  }, [ratingRes])

  useEffect(() => {
    setLoading(true)
    setBookingData([])
    setDatas([])
    if (rslKey && !isBookEnq && mainActiveTab !== 3) {
      dispatch(listBooking(dataOne))
    }
  }, [mainActiveTab, dataOne])

  const handleChgIsBook = (index, value) => {
    setIsBookEnq(true)
    setIsApiCall(true)
    setBookingData([])
    setDatas([])
    setLoading(true)

    if (value === 1) {
      if (rslKey) {
        sessionStorage.setItem('active-type', mainTab[0]?.type)
        dispatch(
          listBooking({
            userId: rslKey,
            email: '',
            loginType: 1,
            type: 6,
            isBookingFlow: 1
          })
        )
      }
      setDataOne(prev => ({ ...prev, type: 6, isBookingFlow: 1 }))
      setIsBookingFlow(1)
      setMainActiveTab(0)
      setCurrentTab(mainTab[0]?.name)
    } else {
      if (rslKey) {
        sessionStorage.setItem('active-type', enquiryTab[0]?.type)
        dispatch(
          listBooking({
            userId: rslKey,
            email: '',
            loginType: 1,
            type: 8,
            isBookingFlow: 2
          })
        )
      }
      setDataOne(prev => ({ ...prev, type: 8, isBookingFlow: 2 }))
      setIsBookingFlow(2)
      setMainActiveTab(0)
      setCurrentTab(enquiryTab[0]?.name)
    }
  }

  const handleTabClick = (index, type, bookType, name) => {
    setCurrentTab(name)
    setIsBookEnq(false)
    setIsApiCall(true)
    setLoading(true)
    setMainActiveTab(index)
    setCabs(null)
    sessionStorage.setItem('active-type', type)
    setTypeVal(type);
    if (type === 11) {
      setTypeActiveTab(0);
      setAdditionalDataForCabs(prev => ({ ...prev, isBookingFlow: bookType }))
      dispatch(bookingCabsList({ ...additionalDataForCabs, isBookingFlow: bookType, bookingType: 0 }))
    } else {
      setDataOne(prev => ({ ...prev, type: type, isBookingFlow: bookType }))
    }
  }

  const handleTypeChange = (val) => {
    setLoading(true);
    setAdditionalDataForCabs(prev => ({ ...prev, isBookingFlow: isBookingFlow }));
    dispatch(bookingCabsList({ ...additionalDataForCabs, isBookingFlow: isBookingFlow, bookingType: val }));
  }

  useEffect(() => {
    if (mainActiveTab === 3 && isBookingFlow === 1) {
      setLoading(true)
      setCabs(null)
      if (bookingListRecCab) {
        setCabs(bookingListRecCab)
        setLoading(false)
      }
    }
  }, [mainActiveTab, bookingListRecCab])

  return (
    <>
      <Seo meta={meta} />
      <div className='header-margin'></div>
      {/* <Header /> */}
      <Header bgColor="#f6f6f6" />

      <div className='dashboard'>
        <div className='dashboard__sidebar bg-white scroll-bar-1'>
          <Sidebar />
          {/* End sidebar */}
        </div>

        <div className='offcanvas offcanvas-start' tabIndex='-1' id='carSidebar'>
          <div className='offcanvas-header'>
            <h5 className='offcanvas-title' id='offcanvasLabel'>Settings</h5>
            <button type='button' className='btn-close' data-bs-dismiss='offcanvas' aria-label='Close' />
          </div>
          <div className='offcanvas-body'>
            <aside className='sidebar y-gap-40  xl:d-block' style={{ marginTop: "10px" }}>
              <Sidebar enableClos={true} />
            </aside>
          </div>
        </div>

        {bookingDetails ? (
          <div className='dashboard__main'>
            <BookingDetailsPage
              mainActiveTab={mainActiveTab}
              subActiveTab={subActiveTab}
              setSubActiveTab={setSubActiveTab}
              setCancelStatus={setCancelStatus}
              cancelStatus={cancelStatus}
              handleBookingCancel={handleBookingCancel}
              loading={loading}
              setLoading={setLoading}
              setSelectedIndex={setSelectedIndex}
              selectedIndex={selectedIndex}
              setDataOne={setDataOne}
              dataOne={dataOne}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              mainTab={mainTab}
              setBookingData={setBookingData}
              bookingData={bookingData}
              setBookingDetails={setBookingDetails}
              bookingDetails={bookingDetails}
              setLoader={setLoader}
              loader={loader}
              handleOpen={handleOpen}
              setDatas={setDatas}
              datas={datas}
              setDirectList={setDirectList}
              tabItems={tabItems}
              queryType={type}
              setIsBookEnq={setIsBookEnq}
            />
          </div>
        ) : (
          <div className='dashboard__main'>
            <div className='dashboard__content main_booking_list'>
              <div className='tab-header'>
                <div className='d-flex justify-content-between'>
                  <div className='row y-gap-20 justify-between items-end'>
                    <div className='col-12'>
                      <div className='d-flex items-center justify-between'>
                        <h1 className='text-30 lh-14 fw-500'>Your trips live here</h1>
                        <ManageAccountsIcon
                          data-bs-toggle='offcanvas'
                          data-bs-target='#carSidebar'
                          className='d-lg-none text-secondary'
                        />
                      </div>
                      <div className='text-15 text-light-1'>
                        This page shows all your bookings. If you made a booking
                      </div>
                    </div>
                  </div>
                </div>

                <div className='booking-tab'>
                  <CustomTab value={value} setValue={setValue} handleChgIsBook={handleChgIsBook} />
                </div>

                <div className="top-tabs-wrapper">
                  {isBookingFlow === 1 ? (
                    <>
                      <div className="top-tabs">
                        {mainTab?.map((tab, index) => (
                          <button
                            className={`top-tab ${tab?.name === currentTab ? "active" : ""}`}
                            onClick={() =>
                              handleTabClick(index, tab.type, isBookingFlow, tab.name)
                            }
                            key={index}
                          >
                            <span className="top-tab-label">{tab?.name}</span>
                          </button>
                        ))}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="top-tabs">
                        {enquiryTab?.map((tab, index) => (
                          <button
                            className={`top-tab ${tab?.name === currentTab ? "active" : ""}`}
                            onClick={() =>
                              handleTabClick(index, tab.type, isBookingFlow, tab.name)
                            }
                            key={index}
                          >
                            <span className="top-tab-label">{tab?.name}</span>
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                <div className="top-tabs-divider"></div>

                <div className="tab-wrapper">
                  <div style={{ width: 'fit-content' }}>
                    <SegmentTab
                      activeTab={segmentActiveTab}
                      setActiveTab={setSegmentActiveTab}
                      tabItems={tabItems}
                      setSubActiveTab={setSubActiveTab}
                      setLoading={setLoading}
                    />
                  </div>

                  {
                    typeVal === 11 &&
                    <div className="arrow">›</div>
                  }

                  {
                    typeVal === 11 &&
                    <div style={{ width: 'fit-content' }}>
                      <TypeTab
                        activeTab={typeActiveTab}
                        setActiveTab={setTypeActiveTab}
                        tabItems={getTabs(cabs?.showPersonalChauffeurTab?.visible)}
                        // setLoading={setLoading}
                        onChange={(newIndex) => handleTypeChange(newIndex)}
                      />
                    </div>
                  }
                </div>
              </div>

              <div className='upcoming-list ul-p'>
                <div className='dashboard__content_tablist'>
                  <div className='rounded-4'>
                    <WishlistTableNew
                      subActiveTab={subActiveTab}
                      setSubActiveTab={setSubActiveTab}
                      cabs={cabs}
                      setCabs={setCabs}
                      rating={rating}
                      setRating={setRating}
                      setDataOne={setDataOne}
                      dataOne={dataOne}
                      setActiveTab={setActiveTab}
                      activeTab={activeTab}
                      setBookingData={setBookingData}
                      setIsApiCall={setIsApiCall}
                      mainActiveTab={mainActiveTab}
                      setMainActiveTab={setMainActiveTab}
                      bookingData={bookingData}
                      setBookingDetails={setBookingDetails}
                      bookingDetails={bookingDetails}
                      setSelectedIndex={setSelectedIndex}
                      selectedIndex={selectedIndex}
                      loading={loading}
                      additionalData={additionalData}
                      setAdditionalData={setAdditionalData}
                      setLoading={setLoading}
                      setDatas={setDatas}
                      datas={datas}
                      setDirectList={setDirectList}
                      tabItems={tabItems}
                    />
                  </div>
                </div>
              </div>

              <Modal
                open={open}
                onClose={handleClose}
                sx={{ margin: '12px' }}
                aria-labelledby='parent-modal-title'
                aria-describedby='parent-modal-description'
              >
                <Box className='bookingDetailmainpopup'>
                  Are you looking to initiate a cancellation? Please note that
                  there may be a cancellation fee associated with this request.
                  <Box className='d-flex direction-row justify-center'>
                    <Box sx={{ mr: '12px' }}>
                      <Button variant='contained' color='error' onClick={handleBookingCancel} disabled={loading}>
                        {loading ? <CircularProgress size={24} /> : 'Yes'}
                      </Button>
                    </Box>
                    <Box>
                      <Button variant='contained' color='primary' onClick={handleClose}>
                        NO
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Modal>
            </div>
          </div>
        )}
      </div>

      <Dialog
        open={rationPopup}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        maxWidth='md'
        fullWidth
      >
        <DialogTitle id='alert-dialog-title'>{"Comments"}</DialogTitle>
        <DialogContent>
          <Grid container sx={{ mt: 1 }}>
            <Grid item md={12} sx={{ position: 'absolute', right: '2px', top: '0px' }}>
              <CancelIcon
                onClick={handleRatingClose}
                style={{ color: '#7bcbc4', cursor: 'pointer', fontSize: '26px' }}
              />
            </Grid>
            <Grid item md={12}>
              <TextField
                id='outlined-basic'
                label='Share details of your own experience'
                variant='outlined'
                multiline
                fullWidth
                required
                rows={8}
                onChange={e => {
                  setMessage('')
                  setDataFilter(prev => ({ ...prev, comments: e.target.value }))
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent>
          <Typography sx={{ color: 'red' }} variant='body1'>
            {message}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRatingClose} variant='outlined'>
            Close
          </Button>
          {loaderWishlist ? (
            <Button onClick={handleSubmit} disabled={dataFilter?.comments === ''} variant='contained'>
              <CircularProgress sx={{ width: 25, height: 25 }} />
            </Button>
          ) : (
            <Button onClick={handleSubmit} disabled={dataFilter?.comments === ''} variant='contained'>
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Index

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}